(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kom-inline-search"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('kom-inline-search'))customElements.define('kom-inline-search',class extends HTMLElement{
 connectedCallback(){if(this.bound)return;this.bound=true;this.input=this.querySelector('input[type="search"]');this.panel=this.querySelector('.kom-search-panel');this.suggestions=this.querySelector('.kom-search-suggestions');this.results=this.querySelector('.kom-search-results');this.status=this.querySelector('.kom-search-status');this.all=this.querySelector('.kom-search-all');this.life=new AbortController();const opt={signal:this.life.signal};this.input.addEventListener('focus',()=>this.open(),opt);this.input.addEventListener('input',()=>{this.open();this.queue()},opt);this.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();this.close();this.input.focus();this.close()}else if(e.key==='ArrowDown'||e.key==='ArrowUp'){const links=[...this.panel.querySelectorAll('a')].filter(link=>link.getClientRects().length);if(this.panel.hidden||!links.length)return;e.preventDefault();const i=links.indexOf(document.activeElement);links[(i+(e.key==='ArrowDown'?1:-1)+links.length)%links.length].focus()}},opt);document.addEventListener('pointerdown',e=>{if(!this.contains(e.target))this.close()},opt);document.addEventListener('focusin',e=>{if(!this.contains(e.target))this.close()},opt)}
 disconnectedCallback(){this.life?.abort();this.request?.abort();clearTimeout(this.timer);this.bound=false}
 open(){this.panel.hidden=false;this.input.setAttribute('aria-expanded','true')}
 close(){this.panel.hidden=true;this.input.setAttribute('aria-expanded','false')}
 queue(){clearTimeout(this.timer);this.request?.abort();const q=this.input.value.trim();this.results.replaceChildren();this.status.textContent='';this.suggestions.hidden=!!q;this.all.hidden=!q;if(!q)return;this.timer=setTimeout(()=>this.search(q),250)}
 async search(q){this.request=new AbortController();const request=this.request;this.status.textContent=this.dataset.loading;try{const url=new URL(this.dataset.endpoint,location.origin);url.search=new URLSearchParams({q,'resources[type]':'product,collection','resources[limit]':'5','resources[options][unavailable_products]':'hide','section_id':'kom-search-results'});const response=await fetch(url,{signal:request.signal});if(!response.ok)throw new Error('search');const html=await response.text();if(request.signal.aborted||q!==this.input.value.trim())return;const doc=new DOMParser().parseFromString(html,'text/html');const content=doc.querySelector('[data-kom-search-results]');if(!content)throw new Error('results');this.results.replaceChildren(...content.childNodes);this.status.textContent=this.results.querySelector('[data-result-count]')?.dataset.resultCount||''}catch(error){if(error.name!=='AbortError'&&q===this.input.value.trim())this.status.textContent=this.dataset.error}}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kom-product-newsletter"] && !Shopify.designMode) return;
  try {
    (() => {
  const popup = document.querySelector('.kom-signup-popup');
  if (!popup) return;
  const key = 'kom-product-signup-dismissed';
  let dismissed = false, elapsed = false;
  try { dismissed = sessionStorage.getItem(key) === '1'; } catch (_) {}
  const details = popup.querySelector('details');
  const hasResponse = details.open;
  if (hasResponse) dismissed = false;
  document.body.appendChild(popup);
  const close = () => {
    dismissed = true;
    popup.hidden = true;
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
  };
  popup.querySelector('.kom-signup-popup__close').addEventListener('click', close);
  popup.addEventListener('keydown', event => { if (event.key === 'Escape') close(); });
  const check = () => {
    if (dismissed) return;
    const busy = document.querySelector('cart-drawer[open],header-sidebar[open],facets-drawer[open],header-search[open],x-modal[open]');
    const editing = document.activeElement?.matches('input,textarea,select') && !popup.contains(document.activeElement);
    const mobilePurchaseOverlap = innerWidth < 700 && !details.open && [...document.querySelectorAll('main variant-picker, main buy-buttons')].some(el => {
      const rect = el.getBoundingClientRect();
      return rect.height > 0 && rect.bottom > innerHeight - 170 && rect.top < innerHeight - 80;
    });
    popup.hidden = Boolean(busy || editing || mobilePurchaseOverlap || (!hasResponse && (!elapsed || scrollY < 180)));
  };
  setTimeout(() => { elapsed = true; check(); }, 12000);
  addEventListener('scroll', check, { passive: true });
  document.addEventListener('dialog:after-show', check);
  document.addEventListener('dialog:after-hide', check);
  document.addEventListener('focusin', check);
  document.addEventListener('focusout', check);
  check();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kom-product-premium"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kom-product-polish')) {
  customElements.define('kom-product-polish', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.section = this.closest('.shopify-section');
      this.polish = this.polish.bind(this);
      this.observer = new MutationObserver(this.polish);
      this.observer.observe(this.section, {childList: true, subtree: true});
      this.guideObserver = new MutationObserver(this.polish);
      this.guideObserver.observe(document.body, {childList: true, subtree: true});
      this.guideTimeout = setTimeout(() => this.guideObserver.disconnect(), 15000);
      this.section.addEventListener('click', event => {
        const button = event.target.closest('.kom-size-guide');
        if (!button) return;
        const trigger = document.querySelector('#sizefox-container [role="button"]');
        if (trigger) trigger.click();
      }, {signal:this.controller.signal});
      this.polish();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.guideObserver?.disconnect();
      clearTimeout(this.guideTimeout);
    }
    polish() {
      const trigger = document.querySelector('#sizefox-container [role="button"]');
      if (trigger) this.section.querySelectorAll('.kom-size-guide[hidden]').forEach(button => button.hidden = false);
      const link = this.section.querySelector('.kom-rating-link');
      const overall = this.section.querySelector('.ezrv-widget_overall_rating');
      if (link && overall && !link.querySelector('.kom-rating-summary')) {
        const labels = overall.querySelectorAll('.ezrv-widget_overall_rating_content');
        const rating = labels[0]?.textContent.match(/[\d.,]+/)?.[0];
        const count = labels[1]?.textContent.match(/\d+/)?.[0];
        if (rating && count) {
          const summary = document.createElement('span');
          summary.className = 'kom-rating-summary';
          summary.textContent = this.dataset.ratingTemplate.replace('[rating]',rating).replace('[count]',count);
          link.append(summary);
          link.classList.add('kom-rating-ready');
        }
      }
      const gallery = this.section.querySelector('product-gallery');
      if (gallery && !gallery.querySelector('.kom-gallery-hint')) {
        const hint = document.createElement('p');
        hint.className = 'kom-gallery-hint';
        hint.textContent = this.dataset.galleryHint;
        gallery.append(hint);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kom-reviews-premium"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kom-reviews-premium')) {
 customElements.define('kom-reviews-premium',class extends HTMLElement {
  connectedCallback() {
   this.section=this.closest('.shopify-section');
   if(!this.section)return;
   this.observer=new MutationObserver(()=>this.enhance());
   this.observer.observe(this.section,{childList:true,subtree:true});
   this.enhance();
  }
  disconnectedCallback(){this.observer?.disconnect();}
  enhance(){
   const root=this.section.querySelector('#ezrv-root');
   if(!root)return;
   const histogram=root.querySelector('.ezrv-widget_rating_count');
   if(histogram&&!histogram.closest('details')){
    const details=document.createElement('details');details.className='kom-review-breakdown';
    const summary=document.createElement('summary');summary.textContent=this.dataset.breakdown;
    details.append(summary);histogram.before(details);details.append(histogram);
   }
   root.querySelectorAll('.ezrv-widget_review_listing_row').forEach(row=>{
    if(row.dataset.komReviewReady)return;
    row.dataset.komReviewReady='true';
    const ratings=row.querySelector('.ezrv-widget_review_rating_option');
    if(ratings&&ratings.children.length>1){
     const details=document.createElement('details');details.className='kom-review-extra';
     const summary=document.createElement('summary');summary.textContent=this.dataset.details;details.append(summary);
     [...ratings.children].slice(1).forEach(child=>details.append(child));row.append(details);
    }
   });
   const list=root.querySelector('.ezrv-widget_review_listings');
   if(list){
    if(!list.dataset.komCarousel){
     list.dataset.komCarousel='true';list.tabIndex=0;list.setAttribute('role','region');list.setAttribute('aria-label',this.dataset.region);
     const hint=document.createElement('p');hint.className='kom-review-swipe';hint.textContent=this.dataset.swipe;list.before(hint);
    }
    const hint=root.querySelector('.kom-review-swipe');if(hint)hint.hidden=list.children.length<2;
    if(this.firstCard!==list.firstElementChild){this.firstCard=list.firstElementChild;list.scrollLeft=0;}
   }
   const labels=['first','previous','next','last'];
   root.querySelectorAll('.ezrv-pagination-link').forEach((link,index)=>{
    if(!link.dataset.komPage){
     link.dataset.komPage='true';link.setAttribute('role','button');link.tabIndex=0;
     link.setAttribute('aria-label',this.dataset[labels[index]]||this.dataset.next);
     link.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();link.click();}});
    }
   });
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
